// Absolute short date for future timestamps (e.g. a delivery hold-until), where
// "ago" phrasing makes no sense. "Jun 7" within the current year, else "Jun 7, 2027".
export function formatShortDate(ts: number, now: number = Date.now()): string {
  const date = new Date(ts);
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  const sameYear = date.getFullYear() === new Date(now).getFullYear();
  return sameYear ? `${month} ${day}` : `${month} ${day}, ${date.getFullYear()}`;
}

// Compact "time since" token for a settled timestamp, matching the medallion's
// countdown style (a single coarse unit, no "ago"): "45s" / "5m" / "2h" / "4d".
// Used in the closed-lot ring where a live lot shows its MM:SS timer.
export function formatElapsedShort(ts: number, now: number = Date.now()): string {
  const sec = Math.max(0, Math.floor((now - ts) / 1000));
  if (sec < 60) return `${sec}s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h`;
  return `${Math.floor(hr / 24)}d`;
}

export function formatAgo(ts: number, now: number = Date.now()): string {
  const diffSec = Math.max(0, Math.floor((now - ts) / 1000));
  if (diffSec < 60) return `${diffSec}s ago`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `${diffHour}h ago`;
  const diffDay = Math.floor(diffHour / 24);
  if (diffDay < 7) return `${diffDay}d ago`;
  const date = new Date(ts);
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  const sameYear = date.getFullYear() === new Date(now).getFullYear();
  return sameYear ? `${month} ${day}` : `${month} ${day}, ${date.getFullYear()}`;
}
